import type { CategorizationRule, KeywordMapping } from '../types';

export const RULES: CategorizationRule[] = [
  {
    category: "Clothing & Apparel",
    keywords: [
      "old navy",
      "oldnavy",
      "gap",
      "banana republic",
      "zara",
      "uniqlo",
      "forever 21",
      "forever21",
      "kohls",
      "macys",
      "nordstrom",
      "tjmaxx",
      "marshalls",
      "ross stores",
      "burlington",
      "dillards",
      "jcpenney",
      "saks",
      "neiman marcus",
      "bloomingdales",
      "anthropologie",
      "urban outfitters",
      "american eagle",
      "hollister",
      "abercrombie",
      "express",
      "loft",
      "ann taylor",
      "j crew",
      "madewell",
      "athleta",
      "lululemon",
      "nike",
      "adidas",
      "under armour",
      "foot locker",
      "famous footwear",
      "dsw",
      "zappos",
      "nordstrom rack",
    ],
  },
];

export const DISPLAY_NAMES: KeywordMapping[] = [
  { keyword: "old navy", displayName: "Old Navy" },
  { keyword: "oldnavy", displayName: "Old Navy" },
  { keyword: "oldnavycom", displayName: "Old Navy" },
  { keyword: "gap", displayName: "Gap" },
  { keyword: "banana republic", displayName: "Banana Republic" },
  { keyword: "h&m", displayName: "H&M" },
  // "h m" pattern for when ampersand is normalized away
  // Sorting by length ensures longer patterns like "fresh m" are checked first
  { keyword: "h m", displayName: "H&M" },
  { keyword: "zara", displayName: "Zara" },
  { keyword: "uniqlo", displayName: "Uniqlo" },
  { keyword: "forever 21", displayName: "Forever 21" },
  { keyword: "forever21", displayName: "Forever 21" },
  { keyword: "kohls", displayName: "Kohl's" },
  { keyword: "macys", displayName: "Macy's" },
  { keyword: "nordstrom", displayName: "Nordstrom" },
  { keyword: "tjmaxx", displayName: "TJ Maxx" },
  { keyword: "marshalls", displayName: "Marshalls" },
  { keyword: "ross stores", displayName: "Ross" },
  { keyword: "lululemon", displayName: "Lululemon" },
  { keyword: "nike", displayName: "Nike" },
  { keyword: "adidas", displayName: "Adidas" },
  { keyword: "foot locker", displayName: "Foot Locker" },
  { keyword: "dsw", displayName: "DSW" },
  { keyword: "zappos", displayName: "Zappos" },
  { keyword: "nordstrom rack", displayName: "Nordstrom Rack" },
];
